/*
 Copyright (c) 2015, salesforce.com, inc. All rights reserved.

 Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
 Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
 Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
 Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

import PropTypes from 'prop-types';
import React from 'react';

import Slider from 'react-slick';
import JourneyTemplateCard from './journey-template-card';

const settings = {
  dots: true,
  infinite: false,
  responsive: [
    { breakpoint: 1300, settings: { slidesToShow: 3, slidesToScroll: 3 } },
    { breakpoint: 1600, settings: { slidesToShow: 4, slidesToScroll: 4 } },
    { breakpoint: 2000, settings: { slidesToShow: 5, slidesToScroll: 5 } },
    { breakpoint: 10000, settings: { slidesToShow: 6, slidesToScroll: 6 } },
  ],
};

function JourneyTemplateCarousel(props) {
  if (props.templates && props.templates.length) {
    return (
      <Slider {...settings}>
        {props.templates &&
          props.templates.map((template) => (
            <div key={template.id}>
              <JourneyTemplateCard template={template} onDeepLink={props.onDeepLink} />
            </div>
          ))}
      </Slider>
    );
  }

  return (
    <div className="journey-templates-loader">
      <div role="status" className="slds-spinner slds-spinner_medium">
        <div className="slds-spinner__dot-a" />
        <div className="slds-spinner__dot-b" />
      </div>
    </div>
  );
}

JourneyTemplateCarousel.propTypes = {
  templates: PropTypes.array,
  onDeepLink: PropTypes.func,
};

JourneyTemplateCarousel.displayName = 'Journey Template Carousel';

export default JourneyTemplateCarousel;
